import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 text-start" }
const _hoisted_3 = { class: "mb-8 flex flex-wrap items-center gap-4" }
const _hoisted_4 = { class: "flex flex-1 flex-wrap items-center gap-4" }
const _hoisted_5 = { class: "flex items-center flex-wrap gap-4" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "flex flex-wrap gap-2" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = { class: "text-white font-bold text-lg" }
const _hoisted_17 = { class: "font-bold text-white" }
const _hoisted_18 = { class: "text-zinc-500 text-xs truncate max-w-[250px]" }
const _hoisted_19 = { class: "text-xs" }
const _hoisted_20 = { class: "flex items-center justify-between pt-2" }
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { class: "flex flex-col items-end" }
const _hoisted_23 = { class: "text-xl font-bold text-white" }
const _hoisted_24 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}

import { ref, computed, onMounted, watch } from 'vue'
import {
  CalendarIcon,
  ArrowsUpDownIcon,
  EyeIcon,
} from '@heroicons/vue/24/outline'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Calendar } from '@/components/ui/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { GetAllOrdersParams, useOrder } from '@/composables/useOrder'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import { useBot } from '@/composables/useBot'
import { Bot } from '@/interfaces/Bot'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { Order } from '@/interfaces/orders/Order'
import { OrderPaymentStatus, OrderPaymentStatusLabels } from '@/enums/orders/OrderPaymentStatus'
import { OrderPaymentMethod, OrderPaymentMethodLabels } from '@/enums/orders/OrderPaymentMethod'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import { Badge } from '@/components/ui/badge'
import PaymentStatusBadge from '@/components/ui/badge/PaymentStatusBadge.vue'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'

// Filters

export default /*@__PURE__*/_defineComponent({
  __name: 'ConsultOrdersView',
  setup(__props) {

const paymentStatus = ref<OrderPaymentStatus>()
const botId = ref<string>('all')
const from = ref<Date>()
const to = ref<Date>()
const perPage = ref('10')

// Table Configuration
const tableHeaders = [
  { key: 'id', label: '#', sortable: false, class: 'w-20' },
  { key: 'customer', label: 'Cliente', sortable: false },
  { key: 'bot', label: 'Bot', sortable: false },
  { key: 'date', label: 'Data', sortable: false },
  { key: 'paymentPlan', label: 'Plano de Pagamento', sortable: false },
  { key: 'status', label: 'Status/Método', sortable: false },
  { key: 'value', label: 'Valor', sortable: false, class: 'text-right' },
  { key: 'actions', label: '', class: 'w-20' },
]

const { getAll } = useOrder()
const { getAll: getAllBots } = useBot()
const bots = ref<Bot[]>([])

// Mock orders data (empty for now)
const orders = ref<IPagination<Order>>()

const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value)
}

// Actions
const sortBy = (key: string) => {
  console.log('Sorting by:', key)
}

const viewSaleDetails = (order: any) => {
  console.log('Viewing order:', order)
}

const reloadAndGetAll = async (params: GetAllOrdersParams) => {
  orders.value = undefined
  orders.value = await getAll(params)
}

watch([() => from.value, () => to.value, () => perPage.value, () => paymentStatus.value, () => botId.value], () => {
  reloadAndGetAll({ from: from.value, to: to.value, perPage: perPage.value, paymentStatus: (paymentStatus.value as string) === 'all' ? undefined : paymentStatus.value, botId: botId.value === 'all' ? undefined : Number(botId.value) })
})

onMounted(() => {
  getAll().then((data) => orders.value = data)
  getAllBots({ perPage: '1000' }).then((data) => bots.value = data.data)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageTitle, null, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode(" Minhas Vendas ")
        ])),
        _: 1
      }),
      _createVNode(PageDescription, null, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" Acompanhe suas vendas de maneira estruturada, obtenha insights para aprimorar sua administração! ")
        ])),
        _: 1
      })
    ]),
    _createVNode(TableContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "mr-4 text-xl font-semibold text-white" }, "Vendas realizadas", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Popover), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(PopoverTrigger), { asChild: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        variant: "outline",
                        class: "w-[240px] justify-start text-left font-normal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(CalendarIcon), { class: "mr-2 h-4 w-4" }),
                          _createTextVNode(" " + _toDisplayString(from.value ? _unref(format)(from.value, 'PPP', { locale: _unref(ptBR) }) : 'Selecione a data inicial'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(PopoverContent), { class: "w-auto p-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Calendar), {
                        mode: "single",
                        initialFocus: "",
                        locale: "pt-BR",
                        selected: from.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = (date) => {
                    from.value = new Date(date.year, date.month - 1, date.day);
                  }),
                        "disabled-dates": { before: new Date() }
                      }, null, 8, ["selected", "disabled-dates"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-gray-500" }, "até", -1)),
              _createVNode(_unref(Popover), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(PopoverTrigger), { asChild: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        variant: "outline",
                        class: "w-[240px] justify-start text-left font-normal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(CalendarIcon), { class: "mr-2 h-4 w-4" }),
                          _createTextVNode(" " + _toDisplayString(to.value ? _unref(format)(to.value, 'PPP', { locale: _unref(ptBR) }) : 'Selecione a data final'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(PopoverContent), { class: "w-auto p-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Calendar), {
                        mode: "single",
                        initialFocus: "",
                        locale: "pt-BR",
                        selected: to.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = (date) => {
                    to.value = new Date(date.year, date.month - 1, date.day);
                  }),
                        "disabled-dates": { before: new Date() }
                      }, null, 8, ["selected", "disabled-dates"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(Select), {
              modelValue: paymentStatus.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((paymentStatus).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectTrigger), { class: "w-[180px]" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectValue), { placeholder: "Todos" })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SelectContent), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectItem), { value: "all" }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("Todos os tipos")
                      ])),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OrderPaymentStatus), (status) => {
                      return (_openBlock(), _createBlock(_unref(SelectItem), { value: status }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(OrderPaymentStatusLabels)[status]), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 256))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(Select), {
              modelValue: botId.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((botId).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectTrigger), { class: "w-[180px]" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectValue), { placeholder: "Bot" })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SelectContent), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectItem), { value: "all" }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("Todos os bots")
                      ])),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bots.value, (bot) => {
                      return (_openBlock(), _createBlock(_unref(SelectItem), {
                        value: String(bot.id)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(bot.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 256))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createVNode(Table, { class: "hidden md:block" }, {
          default: _withCtx(() => [
            _createVNode(TableHeader, null, {
              default: _withCtx(() => [
                _createVNode(TableRow, null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                      return _createVNode(TableHead, {
                        key: header.key,
                        class: _normalizeClass(header.class)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createTextVNode(_toDisplayString(header.label) + " ", 1),
                            (header.sortable)
                              ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                  key: 0,
                                  class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white",
                                  onClick: ($event: any) => (sortBy(header.key))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(TableBody, null, {
              default: _withCtx(() => [
                (orders.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (orders.value.data.length === 0)
                        ? (_openBlock(), _createBlock(TableFallback, {
                            key: 0,
                            colspan: tableHeaders.length,
                            icon: _unref(ArrowsUpDownIcon),
                            title: "Nenhum venda encontrado",
                            description: `Tente ajustar seus filtros ou volte mais tarde`
                          }, null, 8, ["colspan", "icon"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value.data, (order) => {
                        return (_openBlock(), _createBlock(TableRow, {
                          key: order.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TableCell, { class: "whitespace-nowrap text-sm font-medium text-emerald-400" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" #" + _toDisplayString(order.id), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap text-sm font-medium" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(order.customer?.name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap text-sm text-gray-300" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(order.bot?.name || '-'), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap text-sm text-gray-300" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(order.createdAt.toString().split('T')[0].split('-').reverse().join('/')), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap text-sm text-gray-300" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                  _createVNode(_unref(Badge), { variant: "default" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(order.paymentPlan?.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "text-sm text-gray-300 flex flex-col gap-1" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(PaymentStatusBadge, {
                                    status: order.paymentStatus
                                  }, null, 8, ["status"])
                                ]),
                                _createElementVNode("span", _hoisted_8, [
                                  (order.paymentMethod === _unref(OrderPaymentMethod).PIX)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _cache[12] || (_cache[12] = [
                                        _createElementVNode("path", {
                                          d: "M16.5098 5.01L14.5498 3.05C13.1498 1.65 10.8498 1.65 9.44977 3.05L7.48977 5.01C7.09977 5.4 7.09977 6.04 7.48977 6.43L11.2998 10.24C11.6898 10.63 12.3198 10.63 12.7098 10.24L16.5198 6.43C16.8998 6.04 16.8998 5.4 16.5098 5.01Z",
                                          fill: "#fff"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                          d: "M5.01 7.49L3.05 9.45C1.65 10.85 1.65 13.15 3.05 14.55L5.01 16.51C5.4 16.9 6.03 16.9 6.42 16.51L10.23 12.7C10.62 12.31 10.62 11.68 10.23 11.29L6.43 7.49C6.04 7.1 5.4 7.1 5.01 7.49Z",
                                          fill: "#fff"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                          d: "M20.95 9.45L18.99 7.49C18.6 7.1 17.97 7.1 17.58 7.49L13.77 11.3C13.38 11.69 13.38 12.32 13.77 12.71L17.58 16.52C17.97 16.91 18.6 16.91 18.99 16.52L20.95 14.56C22.35 13.15 22.35 10.85 20.95 9.45Z",
                                          fill: "#fff"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                          d: "M7.49005 18.99L9.45005 20.95C10.8501 22.35 13.1501 22.35 14.5501 20.95L16.5101 18.99C16.9001 18.6 16.9001 17.97 16.5101 17.58L12.7001 13.77C12.3101 13.38 11.6801 13.38 11.2901 13.77L7.48005 17.58C7.10005 17.96 7.10005 18.6 7.49005 18.99Z",
                                          fill: "#fff"
                                        }, null, -1)
                                      ])))
                                    : _createCommentVNode("", true),
                                  (order.paymentMethod === _unref(OrderPaymentMethod).CREDIT_CARD)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[13] || (_cache[13] = [
                                        _createElementVNode("path", {
                                          d: "M22.0317 7.55002C22.0317 8.21002 21.4917 8.75002 20.8317 8.75002H3.23174C2.57174 8.75002 2.03174 8.21002 2.03174 7.55002V7.54002C2.03174 5.25002 3.88174 3.40002 6.17174 3.40002H17.8817C20.1717 3.40002 22.0317 5.26002 22.0317 7.55002Z",
                                          fill: "#fff"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                          d: "M2.03174 11.45V16.46C2.03174 18.75 3.88174 20.6 6.17174 20.6H17.8817C20.1717 20.6 22.0317 18.74 22.0317 16.45V11.45C22.0317 10.79 21.4917 10.25 20.8317 10.25H3.23174C2.57174 10.25 2.03174 10.79 2.03174 11.45ZM8.03174 17.25H6.03174C5.62174 17.25 5.28174 16.91 5.28174 16.5C5.28174 16.09 5.62174 15.75 6.03174 15.75H8.03174C8.44174 15.75 8.78174 16.09 8.78174 16.5C8.78174 16.91 8.44174 17.25 8.03174 17.25ZM14.5317 17.25H10.5317C10.1217 17.25 9.78174 16.91 9.78174 16.5C9.78174 16.09 10.1217 15.75 10.5317 15.75H14.5317C14.9417 15.75 15.2817 16.09 15.2817 16.5C15.2817 16.91 14.9417 17.25 14.5317 17.25Z",
                                          fill: "#fff"
                                        }, null, -1)
                                      ])))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_unref(OrderPaymentMethodLabels)[order.paymentMethod]), 1)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap text-sm font-medium text-emerald-400" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(formatCurrency(order.amount)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap text-right text-sm" }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  class: "rounded-lg bg-white/5 p-2 text-gray-400 opacity-0 transition-all hover:bg-white/10 hover:text-white group-hover:opacity-100",
                                  onClick: ($event: any) => (viewSaleDetails(order))
                                }, [
                                  _createVNode(_unref(EyeIcon), { class: "h-4 w-4" })
                                ], 8, _hoisted_11)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], 64))
                  : (_openBlock(), _createBlock(TableRowSkeleton, {
                      key: 1,
                      columns: tableHeaders.length
                    }, null, 8, ["columns"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (orders.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (orders.value.data.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(orders.value.data, (order) => {
                    return (_openBlock(), _createBlock(MobileCard, {
                      key: order.id
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Pedido", -1)),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, "#" + _toDisplayString(order.id), 1),
                              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "h-2 w-2 rounded-full bg-emerald-500" }, null, -1))
                            ])
                          ])
                        ])
                      ]),
                      actions: _withCtx(() => _cache[16] || (_cache[16] = [])),
                      content: _withCtx(() => [
                        _createVNode(MobileDataLabel, { label: "Cliente" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(order.customer?.name), 1),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(order.customer?.email), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(MobileDataLabel, { label: "Datas" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_19, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-zinc-400" }, "Criação:", -1)),
                              _createTextVNode(" " + _toDisplayString(order.createdAt ? new Date(order.createdAt).toLocaleString('pt-BR') : '-'), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(MobileDataLabel, { label: "Produtos" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.bot?.name || '-'), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Status", -1)),
                            _createVNode(PaymentStatusBadge, {
                              status: order.paymentStatus
                            }, null, 8, ["status"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Valor Final", -1)),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(formatCurrency(order.amount)), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_unref(ArrowsUpDownIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                    _cache[20] || (_cache[20] = _createTextVNode(" Nenhum venda encontrado "))
                  ]))
            ]))
          : _createCommentVNode("", true),
        (orders.value?.pagination)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 1,
              "onUpdate:page": _cache[4] || (_cache[4] = page => reloadAndGetAll({ page, to: to.value, from: from.value })),
              data: orders.value?.pagination,
              "per-page": perPage.value,
              "onUpdate:perPage": _cache[5] || (_cache[5] = ($event: any) => ((perPage).value = $event))
            }, null, 8, ["data", "per-page"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})